// src/pages/PasoorGameSelector.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function PasoorGameSelector() {
  const navigate = useNavigate();

  const handleSelect = (gameType) => {
    navigate(`/pasoor/room/${gameType}`);
  };

  return (
    <div style={styles.container}>
      <h2>🃏 انتخاب نوع بازی پاسور</h2>
      <div style={styles.buttonGroup}>
        <button style={styles.button} onClick={() => handleSelect("hokm")}>
          ♠️ حکم
        </button>
        <button style={styles.button} onClick={() => handleSelect("chaharbar")}>
          🃏 چهار برگ
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: 40,
    textAlign: "center",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "center",
    gap: 20,
    marginTop: 20,
  },
  button: {
    padding: "15px 30px",
    fontSize: "18px",
    cursor: "pointer",
  },
};
